import React, { useState } from "react";
import { FaFilter, FaChevronDown, FaChevronUp, FaGamepad } from "react-icons/fa";
import { EXPERIENCES_DATA, EXPERIENCE_CATEGORIES } from "../../data/experiencesData";
import ExperienceCard from "../ui/ExperienceCard";
import { playHoverSound, playClickSound } from "../../utils/audioEffects";

const Journey = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [showAllRoles, setShowAllRoles] = useState(false);

  const filteredExperiences =
    activeCategory === "All"
      ? EXPERIENCES_DATA
      : EXPERIENCES_DATA.filter((e) => e.category === activeCategory);

  // Progressive Disclosure: Show top 4 roles by default unless toggled
  const displayedExperiences = showAllRoles
    ? filteredExperiences
    : filteredExperiences.slice(0, 4);

  return (
    <section
      name="experience"
      aria-label="Professional experience section"
      className="relative w-full bg-transparent text-slate-300 py-20 sm:py-24 border-t border-slate-900 scroll-mt-20 theme-indigo overflow-hidden"
    >
      {/* Ambient Indigo Glow */}
      <div className="ambient-glow animate-pulse-glow bottom-20 left-1/4 w-[500px] h-[500px] bg-indigo-600/15 no-print" />

      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="pb-8 text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-indigo-950/80 border border-indigo-500/40 text-indigo-400 text-xs font-mono uppercase tracking-widest mb-3 shadow-md">
            <FaGamepad className="text-indigo-400 text-xs" /> CAREER EXPERIENCE LOG
          </div>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-slate-100 tracking-tight">
            Work <span className="gradient-text-indigo">Experience</span>
          </h2>
          <p className="mt-3 text-slate-400 text-base sm:text-lg max-w-2xl">
            A comprehensive record of my engineering roles, quantified achievements, and impact.
          </p>
        </div>

        {/* Category Filter Tabs */}
        <div className="flex flex-wrap gap-2 mb-10 no-print">
          <div className="flex items-center gap-2 text-xs font-mono text-slate-400 mr-2 py-2">
            <FaFilter className="text-indigo-400" /> Filter Domain:
          </div>
          {EXPERIENCE_CATEGORIES.map((cat) => (
            <button
              key={cat}
              onMouseEnter={playHoverSound}
              onClick={() => {
                playClickSound();
                setActiveCategory(cat);
              }}
              className={`px-4 py-2 text-xs sm:text-sm font-semibold font-mono rounded-xl transition-all cursor-pointer ${
                activeCategory === cat
                  ? "bg-indigo-600 text-white shadow-lg shadow-indigo-500/30 border border-indigo-400"
                  : "bg-slate-900/80 text-slate-400 hover:text-slate-200 border border-slate-800"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Experience Timeline Stream */}
        <div className="relative border-l-2 border-indigo-900/80 pl-6 sm:pl-10 space-y-10 ml-2 sm:ml-4">
          {displayedExperiences.map((exp, idx) => (
            <div key={`${exp.company}-${exp.title}-${idx}`} onMouseEnter={playHoverSound}>
              <ExperienceCard exp={exp} />
            </div>
          ))}
        </div>

        {/* Progressive Disclosure Toggle Button */}
        {filteredExperiences.length > 4 && (
          <div className="mt-12 text-center no-print">
            <button
              onMouseEnter={playHoverSound}
              onClick={() => {
                playClickSound();
                setShowAllRoles(!showAllRoles);
              }}
              className="px-6 py-3.5 text-sm font-semibold text-indigo-300 bg-slate-900 hover:bg-slate-800 border border-indigo-500/40 hover:border-indigo-400 rounded-xl transition-all inline-flex items-center gap-2 cursor-pointer shadow-lg shadow-indigo-500/10 font-mono"
            >
              <span>
                {showAllRoles
                  ? "Show Top Highlights Only"
                  : `View Complete Career History (${filteredExperiences.length - 4} Additional Roles)`}
              </span>
              {showAllRoles ? <FaChevronUp className="text-xs" /> : <FaChevronDown className="text-xs" />}
            </button>
          </div>
        )}

      </div>
    </section>
  );
};

export default Journey;
